// Typelizer digest a4eca3dd47a86629ae2415262c678810
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/overview/month_end_reopening */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/overview/month_end_reopening', {}, options),
    method: 'post',
  }),
}
